import React from "react";

const Translation = () => {
  return <div>Translation</div>;
};

export default Translation;
